import { BanksApis, KhavarmiyanehApis, SamanApis } from "@payping/api";
import { LoggedOutAction } from "./types";
import { LOGGED_OUT } from "./constants";
import { Unpromisify } from "../../store/types";

export interface DigitalAccountState {
  availableBanks: Unpromisify<ReturnType<typeof BanksApis.getUserAvailableBanksWithCancellationTokenGet>>;
  depositStatements: Unpromisify<
    ReturnType<typeof SamanApis.getDepositStatementsWithDepositStatementModelWithCancellationTokenGet>
  >;
  statementsList: Unpromisify<
    ReturnType<typeof SamanApis.getDepositStatementsWithDepositStatementModelWithCancellationTokenGet>
  >;
  depositBalance: Unpromisify<ReturnType<typeof SamanApis.getDepositBalanceWithCancellationTokenGet>>;
  samanRequestList: Unpromisify<
    ReturnType<typeof SamanApis.getOperationDetailsWithRequestModelWithCancellationTokenPost>
  >;
  samanOverviewDetail: Unpromisify<ReturnType<typeof SamanApis.sendPaymentWithRequestModelWithCancellationTokenPost>>;
  khavarmianeh: {
    status?: Unpromisify<ReturnType<typeof KhavarmiyanehApis.getUserStatusWithCancellationTokenGet>>;
  };
}

export const USER_AVAILABLE_BANKS_LOADED = "USER_AVAILABLE_BANKS_LOADED";
export const SAMAN_DEPOSIT_STATEMENTS_LOADED = "SAMAN_DEPOSIT_STATEMENTS_LOADED";
export const SAMAN_DEPOSIT_STATEMENTS_LIST_LOADED = "SAMAN_DEPOSIT_STATEMENTS_LIST_LOADED";
export const SAMAN_DEPOSIT_BALANCE_LOADED = "SAMAN_DEPOSIT_BALANCE_LOADED";
export const USER_KHAVARMIANEH_STATUS_LOADED = "USER_KHAVARMIANEH_STATUS_LOADED";
export const SAMAN_REQUEST_LIST_LOADED = "SAMAN_REQUEST_LIST_LOADED";
export const SAMAN_UPLOAD_LIST_LOADED = "SAMAN_UPLOAD_LIST_LOADED";
export const SAMAN_OVERVIEW_DETAIL_LOADED = "SAMAN_OVERVIEW_DETAIL_LOADED";

export interface UserBanksLoadedAction {
  type: typeof USER_AVAILABLE_BANKS_LOADED;
  payload: { list: Unpromisify<ReturnType<typeof BanksApis.getUserAvailableBanksWithCancellationTokenGet>> };
}
export interface SamanDepositStatementsLoadedAction {
  type: typeof SAMAN_DEPOSIT_STATEMENTS_LOADED;
  payload: {
    result: Unpromisify<
      ReturnType<typeof SamanApis.getDepositStatementsWithDepositStatementModelWithCancellationTokenGet>
    >;
  };
}
export interface SamanDepositStatementsListLoadedAction {
  type: typeof SAMAN_DEPOSIT_STATEMENTS_LIST_LOADED;
  payload: {
    result: Unpromisify<
      ReturnType<typeof SamanApis.getDepositStatementsWithDepositStatementModelWithCancellationTokenGet>
    >;
  };
}
export interface SamanDepositBalanceLoadedAction {
  type: typeof SAMAN_DEPOSIT_BALANCE_LOADED;
  payload: {
    result: Unpromisify<ReturnType<typeof SamanApis.getDepositBalanceWithCancellationTokenGet>>;
  };
}
export interface UserKhavarmianehStatusAction {
  type: typeof USER_KHAVARMIANEH_STATUS_LOADED;
  payload: Unpromisify<ReturnType<typeof KhavarmiyanehApis.getUserStatusWithCancellationTokenGet>>;
}
export interface SamanRequestListLoadedAction {
  type: typeof SAMAN_REQUEST_LIST_LOADED;
  payload: {
    list: Unpromisify<ReturnType<typeof SamanApis.getOperationDetailsWithRequestModelWithCancellationTokenPost>>;
  };
}
export interface SamanUploadListLoadedAction {
  type: typeof SAMAN_UPLOAD_LIST_LOADED;
  payload: {
    list: Unpromisify<
      ReturnType<typeof SamanApis.getBatchPaymentDetailsByExcelWithRequestModelWithCancellationTokenPost>
    >;
  };
}
export interface SamanOverviewDetailLoadedAction {
  type: typeof SAMAN_OVERVIEW_DETAIL_LOADED;
  payload: {
    result: Unpromisify<ReturnType<typeof SamanApis.sendPaymentWithRequestModelWithCancellationTokenPost>>;
  };
}

export type DigitalAccountActionTypes =
  | UserBanksLoadedAction
  | LoggedOutAction
  | SamanDepositStatementsLoadedAction
  | SamanDepositStatementsListLoadedAction
  | SamanDepositBalanceLoadedAction
  | UserKhavarmianehStatusAction
  | SamanRequestListLoadedAction
  | SamanUploadListLoadedAction
  | SamanOverviewDetailLoadedAction;

const initialState: DigitalAccountState = {
  availableBanks: [],
  depositStatements: {
    statements: [],
    totalRecord: 0,
  },
  statementsList: {
    statements: [],
    totalRecord: 0,
  },
  depositBalance: {
    balance: 0,
  },
  khavarmianeh: {
    status: undefined,
  },
  samanRequestList: {
    paymentDetailsModels: [],
  },
  samanOverviewDetail: {
    amount: undefined,
    description: undefined,
    name: undefined,
    id: undefined,
    trackingId: undefined,
    totalWage: undefined,
  },
};

// eslint-disable-next-line default-param-last
export default function digitalAccount(state = initialState, action: DigitalAccountActionTypes): DigitalAccountState {
  if (action.type === USER_AVAILABLE_BANKS_LOADED) {
    const { list } = action.payload;

    return {
      ...state,
      availableBanks: list,
    };
  }
  if (action.type === SAMAN_DEPOSIT_STATEMENTS_LOADED) {
    const { result } = action.payload;

    return {
      ...state,
      depositStatements: result,
    };
  }
  if (action.type === SAMAN_DEPOSIT_STATEMENTS_LIST_LOADED) {
    const { result } = action.payload;

    return {
      ...state,
      statementsList: result,
    };
  }
  if (action.type === SAMAN_DEPOSIT_BALANCE_LOADED) {
    const { result } = action.payload;

    return {
      ...state,
      depositBalance: result,
    };
  }
  if (action.type === USER_KHAVARMIANEH_STATUS_LOADED) {
    const status = action.payload;

    return {
      ...state,
      khavarmianeh: {
        ...state.khavarmianeh,
        status,
      },
    };
  }

  if (action.type === SAMAN_REQUEST_LIST_LOADED) {
    const { list } = action.payload;

    return {
      ...state,
      samanRequestList: list,
    };
  }
  if (action.type === SAMAN_UPLOAD_LIST_LOADED) {
    const { list } = action.payload;

    return {
      ...state,
      samanRequestList: list,
    };
  }
  if (action.type === SAMAN_OVERVIEW_DETAIL_LOADED) {
    const { result } = action.payload;

    return {
      ...state,
      samanOverviewDetail: result,
    };
  }

  if (action.type === LOGGED_OUT) {
    return initialState;
  }
  return state;
}
